import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import AdminDashboard from './../component/AdminDashboard';
import { observer } from 'mobx-react';

const AdminDashboardPage = observer(() => {
    return (
        <PageWrapper>
            <AdminDashboard />
        </PageWrapper>
    );
});

export default AdminDashboardPage;
